import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import { Control } from '@effector-form';
import {
  Backdrop,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material';
import {
  $sendMessageToApplicantPending,
  messageForm,
} from '../../../models/related-tickets';
import * as Styled from '../styled';

export const SendDialog: FC<{ isOpen: boolean; onClose: () => void }> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation();
  const [sendMessageToApplicantPending] = useUnit([$sendMessageToApplicantPending]);
  const { submittable, submit } = useUnit(messageForm);

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="xs">
      <DialogTitle>{t('MessageToApplicants')}</DialogTitle>

      <DialogContent>
        <DialogContentText>
          <Styled.SendMessageDialog>
            <Backdrop open={sendMessageToApplicantPending}>
              <CircularProgress />
            </Backdrop>

            <Typography variant="body1">{t('MessageWillBeSentToAllRelated')}</Typography>

            <Control.Text
              name="text"
              label={t('Message') as string}
              form={messageForm}
              required
              multiline
              minRows={5}
            />
          </Styled.SendMessageDialog>
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          onClick={submit}
          disabled={!submittable}
        >
          {t('Send')}
        </Button>
        <Button variant="outlined" color="primary" onClick={onClose}>
          {t('cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
